import { RemoteI9Status } from '@dtos/remote-i9-status';
import type { RequestStatus } from '@models/request-status';
import { IRemoteRepresentativeService } from '@services/remote-representative-service';
import {
    computed,
    observable
} from 'mobx';

export interface ISection2ThankyouStore {
    readonly status: RemoteI9Status | null;
    readonly fetchStatusRequestStatus: RequestStatus;
    readonly shouldShowFlowReset: boolean;
    readonly shouldShowFlowFinished: boolean;

    fetchI9Status(): Promise<void>;
}

const flowFinishedStatuses = [
    RemoteI9Status.REPRESENTATIVE_DECLINED,
    RemoteI9Status.REPRESENTATIVE_SIGNED
];

export class Section2ThankyouStore implements ISection2ThankyouStore {
    @observable
    status: RemoteI9Status | null = null;

    @observable
    fetchStatusRequestStatus: RequestStatus = 'inactive';

    constructor(
        private remoteRepresentativeService: IRemoteRepresentativeService
    ) {
    }

    @computed
    get shouldShowFlowFinished(): boolean {
        if (!this.status) {
            return false;
        }

        return flowFinishedStatuses.includes(this.status);
    }

    @computed
    get shouldShowFlowReset(): boolean {
        if (!this.status) {
            return false;
        }

        return this.status === RemoteI9Status.WORKER_PENDING;
    }

    async fetchI9Status(): Promise<void> {
        this.fetchStatusRequestStatus = 'pending';

        try {
            const response = await this.remoteRepresentativeService.getStatusAsync();
            this.fetchStatusRequestStatus = 'success';
            this.status = response.status;
        } catch (error) {
            this.fetchStatusRequestStatus = 'error';
        }
    }
}



// WEBPACK FOOTER //
// ./src/stores/onboarding-review/section2-thankyou-store.ts